import apiClient from '../apiClient';
import type { BaseResponse } from '../../types/base.dto';

export interface DispatchStaffStat {
  staffId: number;
  staffName: string;
  totalDispatched: number;
  dispatchedA: number;
  dispatchedB: number;
  dispatchedC: number;
  dispatchedD: number;
  dispatchedUnknown: number;
}

export interface DispatchTeamStat {
  teamId: number;
  teamName: string;
  totalCreated: number;
  totalSubmitted: number;
  totalDispatched: number;
  dispatchedA: number;
  dispatchedB: number;
  dispatchedC: number;
  dispatchedD: number;
  dispatchedUnknown: number;
  staffStats: DispatchStaffStat[];
}

export interface TriggerTaskResponse {
  total: number;
  cancel: number;
  intercept: number;
  dispatch: number;
}

class DispatchStatsAPI {
  async getStats(date?: string, teamId?: number): Promise<DispatchTeamStat[]> {
    const params: Record<string, any> = {};
    if (date) params.date = date;
    if (teamId) params.teamId = teamId;
    
    const response = await apiClient.get<BaseResponse<DispatchTeamStat[]>>('/dispatch-stats', { params });
    return response.data.data || [];
  }

  async triggerTask(key: string): Promise<TriggerTaskResponse> {
    const response = await apiClient.post<BaseResponse<TriggerTaskResponse>>('/system-tasks/trigger', null, { params: { key } });
    return response.data.data!;
  }
}

export const dispatchStatsApi = new DispatchStatsAPI();
export default dispatchStatsApi;